import React, {
  type RefObject,
  type CSSProperties,
  type ReactNode,
  type ReactElement,
} from "react";

/**
 * Pass a loading state down a component tree, recursing over any fragments
 * */
export const renderChildrenWithLoading = (
  children: React.ReactNode,
  loading: boolean,
) => {
  return React.Children.map(
    children,
    (child: React.ReactElement<Record<string, unknown>>) => {
      if (React.isValidElement(child)) {
        if (React.Fragment === child.type) {
          // If child is a fragment, render its children recursively
          return renderChildrenWithLoading(child.props.children, loading);
        }
        // Clone the child with the loading prop
        return React.cloneElement(child, { loading, ...(child.props as any) });
      }
      return child;
    },
  );
};
